import { render, staticRenderFns } from "./calllog.vue?vue&type=template&id=0aca1859"
import script from "./calllog.vue?vue&type=script&lang=js"
export * from "./calllog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports